import styled from '@emotion/styled'

import { GridCell, Title } from 'mailup-web-components'

const IconFlag = `<svg
      width="21"
      height="21"
      data-name="Flag"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        d="M6.73 1.76L3.9 9.96c3.45 2.12 8 1.17 11.2 3.9l2.64-7.64c-2.56-4.72-7.18-1-11.01-4.46z"
        stroke="#5a5654"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="#3bb7ff"
        stroke-width="1.5"
      />
      <path
        d="M6.66 1L1 17.44"
        fill="none"
        stroke-width="2"
        stroke="#5a5654"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>`

export const WorkflowRight = styled.div`
  flex: 0 0 85%;
  border: 1px solid var(--geyser);
  min-height: 58px;
  margin-top: 8px;
  border-radius: 4px;
`

export const StepType = styled(GridCell)`
  background-color: var(--java);
  color: var(--pure-white);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding: 0 15px;

}
`

export const StepTypeLabel = styled(Title)`
  text-transform: uppercase;
  color: var(--pure-white) !important;
  line-height: 58px !important;
`

export const StepDescription = styled(GridCell)`
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const TimelineStart = styled.div`
  height: 76px;
  background:
    url('data:image/svg+xml;charset=utf8,${encodeURIComponent(IconFlag)}')
      no-repeat center 5px,
    linear-gradient(#eaeaea, #eaeaea) no-repeat center bottom/4px 18px;
`
export const TimelineEnd = styled.div`
  height: 76px;
  background: linear-gradient(#eaeaea, #eaeaea) no-repeat center top/4px 20px;
`

export const Timeline = styled.div`
  height: 76px;
  background:
    radial-gradient(
      circle at center,
      var(--java) 0,
      var(--java) 8px,
      transparent 9px,
      transparent
    ),
    radial-gradient(
      circle at center,
      #8bd3e6 0,
      #8bd3e6 13px,
      transparent 14px,
      transparent
    ),
    linear-gradient(#eaeaea, #eaeaea) no-repeat center top/4px 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const StartEndLabel = styled.p`
  padding-top: 30px;
  padding-bottom: 8px;
  text-transform: uppercase;
  font-weight: 500;
  text-align: center;
  font-size: 15px;
  line-height: 1.3em;
  letter-spacing: 0.03em;
`
